import { AppThunkAction, AppThunkActionAsync } from "..";
import * as actions from "./actions";
import clientApi from "../../api/client";
import { selectClientBenefitList } from ".";
import { IFilterType } from "../filterType";
import { CancelToken } from "axios";
import {
  listEffectCountFilter,
  listEffectGetFilter,
  listEffectLoad,
  listEffectReload,
  listEffectsCountCheck,
  listEffectsGetCheck,
  listEffectsGetCount,
  listEffectsGetNew,
  listEffectsGetParams,
} from "../listEffect";

export function getClientBenefitList(
  clientId: number,
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectClientBenefitList(getState());
    if (listEffectsGetCheck(state.state)) {
      return;
    }

    let newState = listEffectsGetNew(state);
    dispatch(actions.clientBenefitListFetchRequest(newState.newCountState));
    try {
      const params = listEffectsGetParams(state, newState.take);
      listEffectGetFilter(params, state.filter);

      const benefits = await clientApi.getClientBenefitList(clientId, {
        params,
        cancelToken,
      });
      cancelToken.throwIfRequested();
      newState = listEffectsGetCount(newState, benefits);

      dispatch(
        actions.clientBenefitListFetchSuccess({
          data: benefits.data,
          newCountState: newState.newCountState,
          newCount: newState.newCount,
        })
      );
    } catch {
      dispatch(
        actions.clientBenefitListFetchError(cancelToken.reason !== undefined)
      );
    }
  };
}

export function getClientBenefitListCount(
  clientId: number,
  cancelToken: CancelToken
): AppThunkActionAsync {
  return async (dispatch, getState) => {
    const state = selectClientBenefitList(getState());
    if (listEffectsCountCheck(state.countState)) {
      return;
    }

    dispatch(actions.clientBenefitListCountRequest());
    try {
      const params = listEffectCountFilter(state.filter);
      const count = await clientApi.getClientBenefitCount(clientId, {
        params,
        cancelToken,
      });
      cancelToken.throwIfRequested();

      dispatch(actions.clientBenefitListCountSuccess(count.data));
    } catch {
      dispatch(
        actions.clientBenefitListCountError(cancelToken.reason !== undefined)
      );
    }
  };
}

export function changeClientBenefitListOrder(
  orderBy: string,
  orderDesc: boolean
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.clientBenefitListChangeOrder({ orderBy, orderDesc }));
  };
}

export function changeClientBenefitListPage(page: number): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.clientBenefitListChangePage(page));
  };
}

export function changeClientBenefitListFilter(
  filter: IFilterType
): AppThunkAction {
  return async (dispatch) => {
    dispatch(actions.clientBenefitListChangeFilter(filter));
  };
}

export function clientBenefitListLoad(reload: boolean): AppThunkAction {
  return async (dispatch, getState) => {
    const state = selectClientBenefitList(getState());
    reload = listEffectReload(reload, state);
    if (reload) {
      dispatch(actions.clientBenefitListReset());
    } else {
      const newState = listEffectLoad(state);
      dispatch(
        actions.clientBenefitListLoadAction({
          newState: newState.newState,
          newCountState: newState.newCountState,
        })
      );
    }
  };
}
